import { animation, style, animate } from '@angular/animations';

//////////////////////////////////////////
// Fade In and fade out animations
/////////////////////////////////////////

export const fade = animation([
  style({
    opacity: '{{ start }}'
  }),
  animate('{{ time }}', style({
    opacity: '{{ end }}'
  }))
], {
  params: {
    time: '300ms',
    start: 0,
    end: 1
  }
});

//////////////////////////////////////////
// Slide and fade in cubic bezie (modal)
/////////////////////////////////////////

export const slideFade = animation([
  style({
    opacity: '{{ opacityStart }}',
    transform: '{{ translate }}({{ translateStart }})'
  }),
  animate('{{ time }} {{ animationTransition }}', style({
    opacity: '{{ opacityEnd }}',
    transform: '{{ translate }}({{ translateEnd }})'
  }))
], {
  params: {
    time: '500ms',
    animationTransition: 'cubic-bezier(.175,.885,.32,1.275)',
    opacityStart: 0,
    opacityEnd: 1,
    translate: 'translateY',
    translateStart: '-2rem',
    translateEnd: '0'
  }
});
